<template>
  <div class="menu-wrap">
    <div class="title">{{ title }}</div>
    <div class="menu-body">
      <div
        class="menu-item"
        :class="{ active: activeIndex === index }"
        v-for="(v, index) in lists"
        :key="index"
        @click="onClick(v, index)"
      >
        <div class="menu-item-box">
          <div class="menu-item-title">{{ v.text || v.name }}</div>
          <div class="menu-item-body" v-if="v.children">
            <div
              class="children-item"
              v-for="(vv, i) in v.children"
              :key="i"
              @click="onClick(vv, i)"
              :class="{ active: $route.query.cat === vv.id }"
            >
              {{ vv.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    lists: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      activeIndex: /^number$/.test(this.$route.query.type) ? 2 : 0
    };
  },
  methods: {
    onClick(v, i) {
      this.$set(this, "activeIndex", i);
      this.$emit("on-click", { data: v, index: i });
    },
    onMouseenter() {
      console.log(this.$refs.children);
    },
    onMouseleave() {
      console.log(this.$refs.children);
    }
  }
};
</script>

<style lang="less" scoped>
.menu-wrap {
  border: 1px solid rgba(97, 97, 97, 0.29);

  .title {
    padding: 0 20px;
    line-height: 50px;
    font-size: 16px;
    color: var(--color-white);
    background: var(--color-bright-grey);
  }

  .menu-body {
    font-size: 14px;
    background: rgb(245, 245, 245);
    color: var(--color-light-black);

    .menu-item {
      line-height: 50px;
      cursor: pointer;

      .menu-item-box {
        padding: 0 20px;
        position: relative;

        &:hover {
          .menu-item-body {
            display: block;
          }
        }

        .menu-item-body {
          top:0px;
          display: none;
          width: 100%;
          position: absolute;
          left: 238px;
          z-index: 999;
          bottom: 0;
          color: var(--color-grey-black);
          background: rgb(245, 245, 245);
          border: 1px solid var(--color-line-light);
          border-left: none;

          .children-item {
            width : 300px;
            background-color: #e6e6e6;
            padding: 0 20px;

            &.active,
            &:hover {
              background: var(--color-green);
              color: var(--color-white);
            }
          }
          //background: var(--color-green);
        }
      }

      // &.active,
      &:hover {
        color: var(--color-white);
        background: var(--color-green);
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .menu-body {
    overflow-x: auto;
    white-space: nowrap;
    &::-webkit-scrollbar {
      display: none;
    }

    .menu-item {
      display: inline-block;

      &:hover,
      &.active {
        .menu-item-body {
          display: block;
          left: 0 !important;
          position: fixed !important;
          max-height: 500px !important;
          overflow-y: auto !important;
        }
      }
    }
  }
}
</style>
